import React, { useState } from "react";
import MrrCohortsChart from "../components/MrrCohortsChart";
import MrrLineChart from "../components/MrrLineChart";

export default function MrrPage() {
  const [months, setMonths] = useState(12);
  const [excludeCurrentMonth, setExcludeCurrentMonth] = useState(false);

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", gap: 24, marginBottom: 16 }}>

        <select
          value={months}
          onChange={(e) => setMonths(parseInt(e.target.value || "12", 10))}
        >
          <option value={6}>6 months</option>
          <option value={12}>12 months</option>
          <option value={18}>18 months</option>
          <option value={24}>24 months</option>
        </select>

        <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }}>
          <input
            type="checkbox"
            checked={excludeCurrentMonth}
            onChange={(e) => setExcludeCurrentMonth(e.target.checked)}
          />
          Exclude current (in-progress) month
        </label>
      </div>

      {/* Simple line chart (defaults to Net Δ; auto-switches to Total if backend provides total_mrr) */}
      <MrrLineChart months={months} excludeCurrentMonth={excludeCurrentMonth} />

      {/* Stacked columns with drilldown */}
      <MrrCohortsChart months={months} excludeCurrentMonth={excludeCurrentMonth} />


    </div>
  );
}
